import React from 'react';
import { useNavigate } from 'react-router-dom';

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center px-6"
          style={{ background: '#030014' }}
        >
          <div className="text-center space-y-6 max-w-sm">
            <div className="text-4xl">:(</div>
            <h2 className="text-xl font-semibold text-white">
              Oups, quelque chose s'est mal passe
            </h2>
            <p className="text-white/60 text-sm">
              {this.state.error?.message || 'Erreur inattendue'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                this.props.onReset?.();
              }}
              className="px-6 py-3 bg-violet-600 hover:bg-violet-500 text-white rounded-xl font-medium transition-colors"
              data-testid="error-boundary-retry"
            >
              Retour a l'accueil
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ErrorBoundary = ({ children }) => {
  const navigate = useNavigate();
  return (
    <ErrorBoundaryInner onReset={() => navigate('/')}>
      {children}
    </ErrorBoundaryInner>
  );
};

export default ErrorBoundary;
